import React, { Component } from 'react';
import moment from 'moment-timezone';
import InterestedDialog from './InterestedDialog.js';
import AssistantsDialog from './AssistantsDialog.js';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

let cancelToken;
let state;
let tokenSession;

const INTEREST_STATUS = {
  ATTENDING: "1",
  INTERESTED: "2",
  NOT_INTERESTED: "0"
};

class Event extends Component {

  componentWillMount() {
    cancelToken = axios.CancelToken.source();

    const event = JSON.parse(this.props.location.state.event);

    this.updateEventStatus({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      event_id: event.id
    });
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  renderInterestedLink = (interested_number) => {
    const { t } = this.props;

    return (
      <span>
        <a
          className="panel-title text-primary"
          data-target="#modalInterested"
          data-toggle="modal"
          type="button">
          {interested_number === 1 &&
            <span>
              <i className="fa fa-user fa-2x text-primary"></i>&emsp;
              {interested_number + ' ' + t('dashboard.events.one_interested')}
            </span>}
          {interested_number > 1 &&
            <span>
              <i className="fa fa-users fa-2x text-primary"></i>&emsp;
              {interested_number + ' ' + t('dashboard.events.many_interested')}
            </span>}
        </a>
      </span>
    );
  }

  renderAssistantsLink = (assistants_number) => {
    const { t } = this.props;

    return (
      <span>
        <a
          className="panel-title text-primary"
          data-target="#modalAssistants"
          data-toggle="modal"
          type="button">
          {assistants_number === 1 &&
            <span>
              <i className="fa fa-user fa-2x text-primary"></i>&emsp;
              {assistants_number + ' ' + t('dashboard.events.one_assistants')}
            </span>}
          {assistants_number > 1 &&
            <span>
              <i className="fa fa-users fa-2x text-primary"></i>&emsp;
              {assistants_number + ' ' + t('dashboard.events.many_assistants')}
            </span>}
        </a>
      </span>
    );
  }

  renderInterestedDialog = () => {
    return (
      <InterestedDialog />
    );
  }

  renderAssistantsDialog = () => {
    return (
      <AssistantsDialog />
    );
  }

  renderStatusButton = (button, event) => {
    const { t } = this.props;
    let btn_label;
    let btn_class;

    switch (button) {
      default:
      case INTEREST_STATUS.ATTENDING:
        btn_label = t('dashboard.events.btn_assistants');
        btn_class = (event.interested_status === INTEREST_STATUS.ATTENDING) ? 'disabled' : '';
        break;
      case INTEREST_STATUS.INTERESTED:
        btn_label = t('dashboard.events.btn_interested');
        btn_class = (event.interested_status === INTEREST_STATUS.INTERESTED) ? 'disabled' : '';
        break;
      case INTEREST_STATUS.NOT_INTERESTED:
        btn_label = t('dashboard.events.btn_not_interested');
        btn_class = (event.interested_status === INTEREST_STATUS.NOT_INTERESTED) ? 'disabled' : '';
        break;
    }

    return (
      <button
        className={"btn btn-block btn-primary btn-event " + btn_class}
        onClick={() =>
          this.updateEventStatus({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            event_id: event.id,
            status: button
          })
        }
        type="button">
        {btn_label}
      </button>
    );
  }

  updateEventStatus = (params) => {
    this.props.post(
      "/attendEvent",
      params,
      (response) => this.didUpdateStatus(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didUpdateStatus(response) {
    this.props.location.state.event = JSON.stringify(response);
    this.setState({ events: [] });
  }



  render() {
    const event = JSON.parse(this.props.location.state.event);
    const startDate = moment(event.start_date, 'YYYY-MM-DD HH:mm:ss');
    const endDate = moment(event.end_date, 'YYYY-MM-DD HH:mm:ss');
    const { t } = this.props;

    return (
      <div className="content-events">
        <div className="container-events-title">
          <div className="row">
            <div className="col-md-12">
              <h2 className="page-header">{t('dashboard.events.heading')}</h2>
            </div>
          </div>
        </div>
        <div className="container-events">
          <div className="container-room-header card-panel panel panel-default card">
            <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + event.picture + "')" }}>
            </div>
            <div className="card-panel-body">
              <div className="panel-body-title">
                <h4 className="ioscentro">{event.name}</h4>
                <h4 className="iossala">{event.center_name}</h4>
              </div>
              <div className="panel-body-description">
                <div className="panel-description-text">
                  {event.summary}
                </div>
                <div className="row">
                  <div className="contenedor-flexbox data">
                    <div className="contenedor">
                      <i className="fa fa-calendar" aria-hidden="true"></i>
                      {startDate.format('LL')}
                    </div>
                    <div className="contenedor">
                      <i className="fa fa-clock-o" aria-hidden="true"></i>
                      {startDate.format('HH:mm')} - {endDate.format('HH:mm')}
                    </div>
                    <div className="contenedor">
                      <i className="fa fa-map-marker" aria-hidden="true"></i>
                      {event.center_city}
                    </div>
                    {event.assistants.length > 0
                      ? (
                        <div className="contenedor">
                          <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                          {event.assistants.length} personas asistirán
                        </div>
                      )
                      : " "
                    }
                    {event.interested.length > 0
                      ? (
                        <div className="contenedor">
                          <i className="fa fa-star-o" aria-hidden="true"></i>
                          {event.interested.length} personas intersadas
                        </div>
                      )
                      : null

                    }
                  </div>
                  <div className="contenedor-flexbox">
                    <center>
                      {event.interested_status > 0 && this.renderStatusButton(INTEREST_STATUS.NOT_INTERESTED, event)}
                    </center>
                    <br />
                    <center>
                      {this.renderStatusButton(INTEREST_STATUS.INTERESTED, event)}
                      &emsp;&emsp;
                      {this.renderStatusButton(INTEREST_STATUS.ATTENDING, event)}
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-room-description">
            <h4 className="page-header text-primary">
              <strong>{t('dashboard.events.heading_about')}</strong>
            </h4>
            <p>{event.description}</p>
          </div>
          <div className="container-room-direction">
            <div className="container-direction text">
              <h4 className="page-header text-primary">
                <strong>{t('dashboard.reservations.heading_address')}</strong>
              </h4>
              <p>
                <strong>{event.name}</strong>
                {event.center_address.split(",").map((row, index) =>
                  <span key={index} style={{ textTransform: "capitalize" }}>
                    <br />
                    {row.toLowerCase()}
                  </span>
                )}
              </p>
            </div>
            <div className="container-direction mapa">
              <h4 className="page-header text-primary">
              </h4>
              <div className="iframe-wrapper">
                <iframe
                frameBorder="0"
                src={
                  "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                  + event.center_latitude
                  + "%2C"
                  + event.center_longitude
                }
                title={t('dashboard.reservation.frame_center')}>
              </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(Event);



// WEBPACK FOOTER //
// ./src/dashboard/events/Event.js